<div [formGroup]="form">
  <div class="d-flex text-center align-items-center">
    <label class="pr-2 m-0 cursor-pointer" [for]="settings.idName">{{
      settings.label.isActive
    }}</label>
    <label class="switch m-0">
      <input
        type="checkbox"
        #radioSwitch
        class="custom-control-input"
        [checked]="settings.checked"
        [id]="settings.idName"
        [formControlName]="settings.formControlName"
        (change)="valueChange()"
        [value]="settings.value"
        (focus)="onFocusEvent($event)"
        (click)="onClickEvent($event)"
        (blur)="onBlurEvent($event)"
      />
      <span class="slider round"></span>
    </label>
    <label class="pl-2 m-0 cursor-pointer" [for]="settings.idName">{{
      settings.label.isInActive
    }}</label>
  </div>
</div>
